import detailApiCall from './detail';
import listApiCall from './list';
import reinitEsignApiCall from './reinit-esign';
import requestNewEsignApiCall from './request-new-esign';
import syncEsignApiCall from './sync-esign';

const ApiCall = {
  list: listApiCall,
  detail: detailApiCall,
  syncEsign: syncEsignApiCall,
  requestNewEsign: requestNewEsignApiCall,
  reinitEsign: reinitEsignApiCall,
};

export default ApiCall;
